export class AdvisingAbnormalTableAbnormalItemData {
  seqNo: number;
  createUser: string | null;
  createDt: Date | null;
  updateUser: string | null;
  updateDt: Date | null;
  adNo: string;
  waitingReference: string | null;
  waitingReferenceDesc: string | null;
  abnormalCaseCnt: number | null;
  docIds: string[];
  relatedDetailSeqNo: string | null;
  handleMethod: string | null;
  notes: string | null;
  dataKey: string;

  constructor() {
    this.seqNo = -1;
    this.createUser = null;
    this.createDt = new Date();
    this.updateUser = null;
    this.updateDt = new Date();
    this.adNo = "";
    this.waitingReference = null;
    this.waitingReferenceDesc = null;
    this.abnormalCaseCnt = null;
    this.docIds = [];
    this.relatedDetailSeqNo = null;
    this.handleMethod = null;
    this.notes = null;
    this.dataKey = "";
  }
}
